import { getGroupList } from '@/api'
export default {
  data () {
    return {
      groups: [],
      loading: false,
      error: null
    }
  },
  created () {
    this.fetchGroups()
  },
  computed: {
    items () {
      return this.groups.map(group => {
        return {
          text: group.name,
          value: group._id
        }
      })
    }
  },
  methods: {
    async fetchGroups () {
      this.loading = true
      try {
        const query = {
          field: 'name'
        }
        const { groups } = await getGroupList(null, query)
        this.groups = groups
        this.error = null
      } catch (err) {
        console.error(err)
        this.error = err
        this.groups = []
      }
      this.loading = false
    }
  },
  render () {
    return this.$scopedSlots.default({
      items: this.items,
      loading: this.loading,
      error: this.error
    })
  }
}
